export default "__VITE_ASSET__Bwq1rdb1__"